import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conditional-required"
// Makes fields required based on trigger field's value
export default class extends Controller {
  static targets = ["trigger", "dependent"]
  static values = {
    pattern: String  // regex pattern to match
  }

  connect() {
    this.updateRequired()
  }

  updateRequired() {
    const triggerText = this.triggerTarget.options[this.triggerTarget.selectedIndex]?.text || ""
    const shouldBeRequired = new RegExp(this.patternValue).test(triggerText)

    this.dependentTargets.forEach(field => {
      field.required = shouldBeRequired
    })
  }
}
